import { render } from "./StatusCard.vue?vue&type=template&id=91752240&scoped=true&ts=true"
import script from "./StatusCard.vue?vue&type=script&lang=ts"
export * from "./StatusCard.vue?vue&type=script&lang=ts"

import "./StatusCard.vue?vue&type=style&index=0&id=91752240&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91752240"]])

export default __exports__